import React from 'react'
import axios from 'axios'
import { Field, reduxForm } from 'redux-form'

class StepOne extends React.Component {
	
	verifyInputs() {
		const { name, username } = this.props
		if (!name || !username) {
			this.props.renderError("Please complete all fields")
			return
		}
		let url = `http://107.170.197.5:8080/api/users/validate?type=username`
		let data = JSON.stringify({
			username: username
		})
		axios.post(url, data, {headers:{'Content-Type':'application/json'}})
		.then((response) => {
			this.props.nextStep()
		})
		.catch((error) => {
			this.props.renderError("Username has been used already")
			return
		})
	}
	
	handleKeyPress(e) {
		if(e.key == 'Enter'){
			this.verifyInputs()
		}
	}
	
	render() {
		return (
			<div>
				<label>Name</label>
				<Field name="name" className="form-control" component="input" type="text" onKeyPress={ this.handleKeyPress.bind(this) } />
				<label>Username</label>
				<Field name="username" className="form-control" component="input" type="text" onKeyPress={ this.handleKeyPress.bind(this) } />
				<button type="button" className="btn btn-login" onClick={ this.verifyInputs.bind(this) }>Next step</button>
			</div>
		)
	}
}

export default StepOne


// WEBPACK FOOTER //
// ./src/components/Modals/StepOne.js